// OFFICIAL SUPPORT EMAIL — user-designated official BuildEase support address.
export const CONTACT_EMAILS = [
    {
        label: "SUPPORT",
        desc: "Questions about BuildEase, the pilot, or working with us as a professional.",
        email: "support@buildease.co.za",
        subject: "BuildEase Support Request",
    },
];

// PLACEHOLDER SOCIAL URLS — replace with official BuildEase accounts when configured.
export const SOCIAL_LINKS = [
    { label: "Instagram", url: "#" },
    { label: "Facebook", url: "#" },
    { label: "TikTok", url: "#" },
];
